import './Endereco.css';
import { useState } from 'react';
import { useCookies } from "react-cookie";
import { HiOutlineLockClosed } from "react-icons/hi";
import { useNavigate } from 'react-router-dom'
import EtapaEndereco from '../../../components/Banners/EtapaEndereco/EtapaEndereco.js'
import BannerEnderecoPhone from '../../Banners/BannerEenderecoPhone/BannerEnderecoPhone.js'
import Input from '../../../components/Input/input';
import Button from '../../../components/Button/button';
import axios from 'axios';
import api from '../../../services/api.js';
import Loading from '../../Loading/Loading.js'

function Endereco() {
    const [isShow, setShow] = useState(false);
    const [cookies] = useCookies(['__gtm_campaign_url']);
    const [fieldsValidity, setFieldsValidity] = useState([]);
    const [isChecked, setIsChecked] = useState(true)
    const [payload, setPayload] = useState([]);
    const [logradouro, setUseEndereco] = useState('');
    const [bairro, setBairro] = useState('');
    const [cidade, setUseCidade] = useState('');
    const [uf, setUseEstado] = useState('');
    const [mensagemErroFormulario, setMensagemErroFormulario] = useState('');
    const navigate = useNavigate();
    const encode_data = sessionStorage.getItem("encode_data")
    const idadeMaior = sessionStorage.getItem("idadeMaior")
    const titulo = (idadeMaior == "false" ? 'Endereço Residencial' : 'Preencha os campos abaixo com as informações do seu endereço residencial');

    // INICIO: payloadStorage
    const payloadSended = sessionStorage.getItem("payloadSendedEndereco")
    const payloadStorage = JSON.parse(payloadSended);
    // console.log("payloadSendedEndereco", payloadStorage);
    // FINAL: payloadStorage

    function convertCookie(cookieUrl) {
        const rawParams = cookieUrl?.split("?")?.[1]?.split("&");
        const wantedParams = [
            "utm_source",
            "utm_medium",
            "utm_campaign",
            "utm_id",
            "utm_content",
            "utm_term",
            "gclid",
            "fbclid",
            "aff_click_id",
        ];

        const cleanParams = {}

        if (rawParams) {
            for (const rawParam of rawParams) {

                const [key, value] = rawParam.split("=");

                if (key == 'aff_click_id') {
                    axios.get(`https://api.vsboon.com.br/reward/delivery/savvi?aff_click_id=${value}&action_type=Inapp`)
                        .then(() => {
                            //   console.log('deu certo')
                        })
                        .catch(() => {
                            //   console.log('deu errado')
                        })
                }
                if (key && value && wantedParams.includes(key)) {

                    cleanParams[key] = value;
                }
            }
            return cleanParams;
        }

        return {};
    }

    let buttonContinuar = document.querySelector(".btnContinuar");
    let buttonVoltar = document.querySelector(".btnVoltar");
    let btnContinuar = "btnContinuar"
    let btnVoltar = "btnVoltar"
    
    /*
     *  Validar campos
        Função para validar os campos sem bloquealos.
        No formato atual esta conflitando com algum script.
        SEGREGAR EM UM ARQUIVO A PARTE
    */
    function validaCampos(){
        let validado = 0;

        // Validar campo endereço
        let cmpEndereco = document.getElementById("endereco");
        if(cmpEndereco.value == ""){
            cmpEndereco.classList.add("cmpErro")
            validado++;
        }else{
            cmpEndereco.classList.remove("cmpErro")
        }

        // Validar campo CEP
        let cmpCep= document.getElementById("cep");
        if(cmpCep.value == ""){
            cmpCep.classList.add("cmpErro")
            validado++;
        }else{
            cmpCep.classList.remove("cmpErro")
        }

        // Validar campo Numero
        let cmpNumero= document.getElementById("numero");
        if(cmpNumero.value == ""){
            cmpNumero.classList.add("cmpErro")
            validado++;
        }else{
            cmpNumero.classList.remove("cmpErro")
        }

        // Validar campo Bairro
        let cmpBairro= document.getElementById("bairro");
        if(cmpBairro.value == ""){
            cmpBairro.classList.add("cmpErro")
            validado++;
        }else{
            cmpBairro.classList.remove("cmpErro")
        }

        // Validar campo Estado
        let cmpEstado= document.getElementById("estado");
        if(cmpEstado.value == ""){
            cmpEstado.classList.add("cmpErro")
            validado++;
        }else{
            cmpEstado.classList.remove("cmpErro")
        }

        // Validar campo Cidade
        let cmpCidade= document.getElementById("cidade");
        if(cmpCidade.value == ""){
            cmpCidade.classList.add("cmpErro")
            validado++;
        }else{
            cmpCidade.classList.remove("cmpErro")
        }   

        console.log("Campos com erro", validado);

        if(validado > 0){
            setMensagemErroFormulario("Favor preencher os campos contornados em vermelho para prosseguir.");
            return false;
        }else {
            setMensagemErroFormulario("");
            return true;
        }
    }


    async function handleSubmit(e) {
        e.preventDefault();
        const errors = [];

        const requestApi = validaCampos();
        console.log("requestApi", requestApi);

        if (!requestApi) {
            return;
        }
        
        if (errors.length === 0) {
            let cep_user = payload.cep;
            let cep = "";
            if(cep_user != undefined){
                cep = cep_user.replace("-", "")
            }

            const enderecoId =  document.getElementById("endereco");
            const logradouro = enderecoId.value;

            const numero = payload.numero;
            
            let complemento = payload.complemento;

            const bairroId =  document.getElementById("bairro");
            const bairro = bairroId.value;

            const ufId =  document.getElementById("estado");
            const uf = ufId.value;

            const cidadeId =  document.getElementById("cidade");
            const cidade = cidadeId.value;

            if (complemento === undefined) {
                complemento = ""
            }
          
            const endereco = {
                uf,
                cep,
                bairro,
                cidade,
                logradouro,
                numero,
                complemento,
            }
            const sendbackend = {
                endereco
            }
            // console.log(endereco)
            const JsonArray = JSON.stringify(sendbackend)// transforma meu array em json para enviar para o backend
            const json_obj = JSON.parse(JsonArray)

            sessionStorage.setItem("sessionUf", uf);
            sessionStorage.setItem("sessionCidade", cidade);

            setShow(true);
            api.put(`/crefaz/update/${encode_data}`, json_obj, {
            })
                .then((response) => {

                    console.log(response.data.cod_erro);

                    if (response.data.cod_erro == 2 && response.data.ofertas == null){
                        navigate("/atencao")
                        setShow(false);
                    } else {
                        navigate("/simulacao")
                        setShow(false);
                    }
                })
                .catch(() => {
                    setShow(false);
                    navigate("/contato")
                    console.log("Error! Send json", JsonArray)
                })   
        }
    }

    const handleChangeInputs = (value, prop) => {
        setPayload({ ...payload, [prop]: value })
    }

    const checkCEP = (e) => {
        if (!e.target.value) return;
        const cep = e.target.value.replace(/\D/g, '');
        
        setShow(true);
        axios.get(`https://viacep.com.br/ws/${cep}/json/`)
        .then(result => {
            // console.log(result.data)
            setUseEndereco(result.data.logradouro)
            setBairro(result.data.bairro)
            setUseCidade(result.data.localidade)
            setUseEstado(result.data.uf)

            let input = document.getElementById("numero");
            input.focus();
            input.select();

            setTimeout(() => {
                validaCampos();
                setShow(false);
            }, 1000);
            
        })
        .catch(() => {
            setShow(false);
            // console.log("Cep não encontrado")
            const errors = [];
        });
    }

    const exceptThisSymbols = ["+", "-", ".", "1", "2", "3", "4", "5", "6", "7", "8", "9", "0", "=", "!", "@", "#", "$", "%", "&", "*", "(", ")", "_", "[", "]", "{", "}", "'", "?", "/"];
    return (
        <div className="home">
            <div className='mobile'>{isShow && <Loading />}</div>
            <EtapaEndereco />
            <BannerEnderecoPhone />
            <form
                className='container2'
                onSubmit={handleSubmit}
            >
                <div className='form'>
                    <div className='titleform'>
                        <h4 className='titleMob'>{ titulo }</h4>
                    </div>
                    <div className='spaceform'></div>
                    <div className='Input-form'>
                    <div className='group'>
                            <label className='label'><b>CEP</b></label>
                            <Input
                                id="cep"
                                onChange={(e) => handleChangeInputs(e.target.value, "cep")}
                                onKeyDown={e => exceptThisSymbols.includes(e.key)}
                                value={payload.cep}
                                name="cep"
                                type="text"
                                placeholder='00000-000'
                                length="9"
                                mask="99999-999"
                                error={fieldsValidity}
                                handleOnBlur={checkCEP}
                            />
                        </div>
                        <div className='spaceform'></div>
                        <div className='group'>
                            <label className='label'><b>Endereço</b></label>
                            <Input
                                onChange={(event) =>
                                    setUseEndereco(event.target.value) || handleChangeInputs(event.target.value, "endereco")
                                }
                                onKeyDown={e => exceptThisSymbols.includes(e.key) && e.preventDefault()}
                                value={logradouro}
                                id="endereco"
                                name="endereco"
                                length="250"
                                type="text"
                                placeholder='Endereço'
                                error={fieldsValidity}
                            />
                        </div>
                        <div className='spaceform'></div>
                        <div className='group'>
                            <label className='label'><b>Número</b></label>
                            <Input
                                onChange={(e) => handleChangeInputs(e.target.value, "numero")}
                                onKeyDown={e => exceptThisSymbols.includes(e.key)}
                                value={payload.Numero}
                                type="text"
                                name="numero"
                                id="numero"
                                length="10"
                                placeholder='Número'
                                error={fieldsValidity}
                            />
                        </div>
                        
                        <div className='spaceform'></div>

                        <div className='group'>
                            <label className='label'><b>Complemento</b></label>
                            <Input
                                onChange={(e) => handleChangeInputs(e.target.value, "complemento")}
                                value={payload.Complemento}
                                name="Complemento"
                                length="150"
                                placeholder='Complemento'
                                error={fieldsValidity}
                            />
                        </div>
                        
                        <div className='spaceform'></div>

                        <div className='group'>
                            <label className='label'><b>Bairro</b></label>
                            <Input
                                id="bairro"
                                onChange={(event) =>
                                    setBairro(event.target.value) || handleChangeInputs(event.target.value, "bairro")
                                }
                                value={bairro}
                                name="bairro"
                                length="150"
                                placeholder='Bairro'
                                error={fieldsValidity}
                            />
                        </div>
                        
                        <div className='spaceform'></div>

                        <div className='group'>
                            <label className='label'><b>Estado</b></label>
                            <div className="cmpSelect">
                            <Input
                                id="estado"
                                onChange={(event) =>
                                    setUseEstado(event.target.value) || handleChangeInputs(event.target.value, "uf")
                                }
                                value={uf}
                                name="uf"
                                length="150"
                                placeholder='Uf'
                                error={fieldsValidity}
                            />
                            </div>
                        </div>
                        
                        <div className='spaceform'></div>

                        <div className='group'>
                            <label className='label'><b>Cidade</b></label>
                            <Input
                                id="cidade"
                                onChange={(event) =>
                                    setUseCidade(event.target.value) || handleChangeInputs(event.target.value, "cidade")
                                }
                                value={cidade}
                                name="cidade"
                                length="150"
                                placeholder='Cidade'
                                error={fieldsValidity}
                            />
                        </div>
                        
                        <div className='spaceform'></div>

                        <div className='mensagemErroFormulario'>{mensagemErroFormulario}</div>

                        <Button
                            id="btnContinuar"
                            message='CONTINUAR'
                            className={btnContinuar}
                            isChecked={isChecked}
                        />

                        <button
                            className={btnVoltar}
                            cursor='pointer'
                            onClick={() => navigate("/")}>
                            VOLTAR
                        </button>

                        

                        <div className='space1'></div>
                    </div>

                    
                </div>
            </form >
        </div >
    );
}

export default Endereco;